import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ExecutionSalesOrderWizardComponent } from './execution-sales-order-wizard.component';
import { ExecutionDraftLaunchData } from './execution-sales-order.model';

@Injectable({ providedIn: 'root' })
export class ExecutionSalesOrderLauncherService {
  constructor(private dialogs: DialogService) {}

  open(data: ExecutionDraftLaunchData): DynamicDialogRef {
    return this.dialogs.open(ExecutionSalesOrderWizardComponent, {
      header: data.orderId ? 'Import New Execution Charges' : 'Create Sales Order Draft',
      width: 'min(1100px, 96vw)',
      modal: true,
      closable: true,
      dismissableMask: false,
      data
    });
  }
}
